import { call, put, takeLatest } from 'redux-saga/effects'

import {
  postFarm,
  putFarm,
  inactivateFarm as inactivateFarmResource,
  deleteFarm
} from '@galo-monitor/services/apis/galoMonitorApi/resources/farm'
import { getUserFarms } from '@galo-monitor/services/apis/galoMonitorApi/resources/session'

import { FarmActions, FarmTypes } from './duckFarm'

function* saveFarm({ farm, onSuccess = () => {}, onError = () => {} }) {
  try {
    yield call(
      farm.id ? putFarm : postFarm,
      { ...farm }
    )
    yield call(onSuccess)
  } catch (err) {
    yield put(FarmActions.farmError(err.message))
    yield call(onError, err)
  }
}

function* inactivateFarm({ farm, onSuccess = () => {}, onError = () => {} }) {
  try {
    yield call(inactivateFarmResource, farm)
    yield call(onSuccess)
  } catch (err) {
    yield put(FarmActions.farmError(err.message))
    yield call(onError, err)
  }
}

function* removeFarm({ farm, onSuccess = () => {}, onError = () => {} }) {
  try {
    yield call(deleteFarm, farm)
    yield call(onSuccess)
  } catch (err) {
    yield put(FarmActions.farmError(err.message))
    yield call(onError, err)
  }
}

function* loadUserFarms({ onSuccess = () => {}, onError = () => {} }) {
  try {
    const { data } = yield call(getUserFarms)
    yield put(FarmActions.loadUserFarmsSuccess(data))
    yield call(onSuccess)
  } catch (err) {
    yield put(FarmActions.farmError(err.message))
    yield call(onError, err)
  }
}

export default [
  takeLatest(FarmTypes.SAVE_FARM, saveFarm),
  takeLatest(FarmTypes.INACTIVATE_FARM, inactivateFarm),
  takeLatest(FarmTypes.REMOVE_FARM, removeFarm),
  takeLatest(FarmTypes.LOAD_USER_FARMS, loadUserFarms)
]
